import { Box, styled } from '@mui/material';

import { COLORS, RESET_PILL } from '../../../IndividualPlan/tokens';

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  alignSelf: 'stretch',
});

const Divider = styled(Box)({
  width: 1,
  flex: 1,
  minHeight: 12,
  backgroundColor: COLORS.hairline,
});

const Label = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: 'dark' | 'light' }>(({ tone }) => ({
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.08em',
  whiteSpace: 'nowrap',
  color: tone === 'light' ? RESET_PILL.mini.fg : RESET_PILL.full.fg,
  backgroundColor: tone === 'light' ? RESET_PILL.mini.bg : RESET_PILL.full.bg,
  borderRadius: 4,
  padding: '8px 4px',
  writingMode: 'vertical-rl',
}));

export function ScaleResetMarker({ tone = 'dark' }: { tone?: 'dark' | 'light' }) {
  return (
    <Container data-testid="scale-reset-marker">
      <Divider data-testid="scale-reset-divider" />
      <Label tone={tone}>Scale Reset</Label>
      <Divider />
    </Container>
  );
}
